const testimonials = [
  {
    name: "Marcus J.",
    location: "Buckhead, Atlanta, GA",
    rating: 5,
    text: "I had a business trip to Tokyo in 6 days and my passport was expired. Fast Passport Center got me an expedited passport in 4 days flat. They answered my calls at 8 PM and walked me through every step. Absolutely saved my career.",
    service: "Emergency Passport",
  },
  {
    name: "Danielle R.",
    location: "Midtown, Atlanta, GA",
    rating: 5,
    text: "We planned a honeymoon to Greece and realized my fiancé's passport had less than 6 months validity. Started online from our apartment in Midtown, shipped from the UPS Store on Peachtree, and had the renewal back in 7 days. Stress-free.",
    service: "Passport Renewal",
  },
  {
    name: "Keisha W.",
    location: "Decatur, GA",
    rating: 5,
    text: "My son needed a passport for a school trip to Costa Rica. I had no idea both parents had to be there or what forms we needed. Fast Passport Center sent us a perfect checklist, told us exactly which clerk to visit in Decatur, and handled the rest. Got it in 8 days.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function AtlantaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Atlanta Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Atlanta, Buckhead, Midtown, Decatur, and metro Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}